<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
-->
<template>
  <div class="main-container scrollbar-y">
    <div class="page-header">
      <div class="page-title">供求管理</div>
    </div>
    <div class="page-body">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button size="mini" type="primary" round v-on:click="handlerEdit(0)" style="margin-bottom:8px"><i class="el-icon-plus"></i> 添加供求</el-button>
          <el-table :data="dataList" size="mini" border header-row-class-name="datalist-header" style="width: 100%; margin-top: 3px;">
            <el-table-column type="index" label="序号" width="45" align="center"></el-table-column>
            <!--<el-table-column prop="no" label="供求编号" align="center" width="80"></el-table-column>-->
            <el-table-column prop="content" label="内容" header-align="center">
              <template v-slot:default="scope">
                <div style="width: 100%; overflow:hidden; white-space: nowrap; text-overflow: ellipsis; -o-text-overflow:ellipsis;">{{scope.row.content}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="供求类型" width="60" align="center"></el-table-column>
            <el-table-column prop="create_time" label="日期" width="130" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template v-slot:default="scope">
                <el-button size="mini" type="warning" circle v-on:click="handlerEdit(scope.row.id)"><i class="el-icon-edit"></i></el-button>
                <el-button size="mini" type="danger" circle v-on:click="handlerDelete(scope.row)"><i class="el-icon-delete"></i></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top: 20px;" v-on:size-change="handlerSizeChange" v-on:current-change="handlerCurrentChange" :current-page="query.pn" :page-sizes="[15, 30, 50, 100]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>

        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
// import apis from './module.apis.js'
export default {
  name: 'supply_demand_list',
  data: () => {
    return {
      query: {
        startDate: '',
        endDate: '',
        pageSize: 15,
        pn: 1
      },
      // 日期范围
      dateRange: [],
      dataList: [],
      pageCount: 0,
      totalCount: 0,

      parentIds: ['0'],
      apis: {
        getSupplyDemands: window.g.baseUrl + 'plugin/user/website/supply/Index',
        deleteSupply: window.g.baseUrl + 'plugin/user/website/supply/delete'
      }
    }
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    loadData: function () {
      const _this = this
      _this.post(_this.apis.getSupplyDemands, _this.query, function (res) {
        const _json = res.data
        _this.dataList = _json.dataList
        _this.totalCount = _json.totalCount
        _this.query.pn = _json.pn
      })
    },

    handlerDelete: function (row) {
      const _this = this
      _this
        .$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.post(_this.apis.deleteSupply, { id: row.id }, function (res) {
            const _json = res.data
            if (_json.status === 'ok') {
              _this.$message({
                message: '操作成功',
                type: 'success'
              })
              _this.loadData()
            } else {
              _this.$message.error('操作失败')
            }
          })
        })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handlerSearch: function () {
      this.loadData()
    },
    handlerSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadData()
    },
    handlerCurrentChange: function (pageIndex) {
      this.query.pn = pageIndex
      this.loadData()
    },
    // 编辑
    handlerEdit: function (_id) {
      this.$router.replace({
        path: '/supply/form/' + _id + '/' + this.categoryIds
      })
    }
  }
}
</script>